import { Space, Alert } from 'antd';
import styled from 'utils/styled';

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const FormContainer = styled(Space)`
  width: 300px;
  padding-bottom: 40px;
`;

export const StyledAlert = styled(Alert)`
  width: 100%;
`;
